export const ADMIN_ROLE_ID = 1;
export const FRONT_OFFICE_ID = '2';
export const INVENTORY_MANAGER_ID = '3';
export const ANALYST_ROLE_ID = '4';
export const FINANCE_ROLE_ID = '6';

export const getRoleById = (roleId: string) => {
  switch (roleId) {
    case ADMIN_ROLE_ID.toString():
      return 'Admin';
    case FRONT_OFFICE_ID:
      return 'Front Office';
    case INVENTORY_MANAGER_ID:
      return 'Inventory Manager';
    case ANALYST_ROLE_ID:
      return 'Analyst';
    case FINANCE_ROLE_ID:
      return 'Finance';
    default:
      return '';
  }
};
